module.exports = __webpack_public_path__ + "static/media/story-4.a9fc93b8.jpg";